import React, { lazy, Suspense } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CopilotProvider } from '@bbkAdminComponents/app-layout/copilot-provider';
import { EndOfPlanBanner } from '@bbkAdminComponents/settings/plans/end-of-plan-banner';
import { GetStartedBanner } from '@bbkAdminComponents/settings/plans/get-started-banner';
import { StarterUpgradeBanner } from '@bbkAdminComponents/settings/plans/starter-upgrade-banner';
import { LoggedInRouter } from '@bbkAdminRouter/logged-in.router';
import { cs } from '@bbkAdminUtils/css-utils';
import { defaultMUiTheme } from '@bbkShared/material-ui-theme';
import { usePageTitle } from '@bbkShared/utils/page-title';

import './app-root.scss';
import './styles/layout.scss';

const LeftColumnV2 = lazy(
  () => import('@bbkAdminComponents/app-layout/left-column-v2')
);

export const AppRoot: React.FC = () => {
  usePageTitle();
  const theme = createTheme(defaultMUiTheme);
  return (
    <CopilotProvider>
      <div className="tw-box-border" id="bbk-app-root">
        <ThemeProvider theme={theme}>
          <div
            className={cs('tw-flex tw-flex-col', 'tw-h-screen tw-max-h-screen')}
          >
            <GetStartedBanner />
            <StarterUpgradeBanner />
            <EndOfPlanBanner />
            <div className="bbk-layout column-layout">
              <Suspense>
                <LeftColumnV2 />
              </Suspense>
              <LoggedInRouter />
            </div>
          </div>
        </ThemeProvider>

        {/* For when needed in a component */}
        <div id="chartjs-portal" />
      </div>
    </CopilotProvider>
  );
};
